export const PERMISSION_INFO = {
  create: { key: 'create_check', permission: 'creatable' },
  read: { key: 'read_check', permission: 'readable' },
  update: { key: 'update_check', permission: 'updatable' },
  delete: { key: 'delete_check', permission: 'deletable' },
  export: { key: 'export_check', permission: 'exportable' },
  approve: { key: 'approve_check', permission: 'approvable' },
  is_active: { key: 'is_active', permission: 'is_active' },
}

export const PERMISSION_LIST = ['create', 'read', 'update', 'delete', 'export', 'approve','is_active']
